export enum MspInProductTrialStatus {
  NOT_APPLICABLE = 0,
  TRIAL_AVAILABLE = 1,
  IN_TRIAL = 2,
  TRIAL_EXPIRED = 3,
}
